/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyEvent = {
    start: string;
    end: string;
    id: string;
    description?: string;
    calendarId: string;
    isBlocking: boolean;
    provider: ThirdPartyEvent.provider;
    title: string;
    color: string;
    isAllDay: boolean;
};
export namespace ThirdPartyEvent {
    export enum provider {
        GOOGLE = 'google',
        MICROSOFT = 'microsoft',
        ICAL = 'ical',
    }
}

